export function saveWalletConfig(state) {
  return {
    type: 'SAVE_WALLET_CONFIG',
    payload: state
  }
}
export function saveWalletItems(state) {
  return {
    type: 'SAVE_WALLET_ITEMS',
    payload: state
  }
}
export function saveWalletPills(state) {
  return {
    type: 'SAVE_WALLET_PILLS',
    payload: state
  }
}
export function saveWalletFilters(state) {
  return {
    type: 'SAVE_WALLET_FILTERS',
    payload: state
  }
}
export function saveWalletPagination(state) {
  return {
    type: 'SAVE_WALLET_PAGINATION',
    payload: state
  }
}
